var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import Tabs from 'material-ui/Tabs/Tabs';
import Tab from 'material-ui/Tabs/Tab';
import AppBar from 'material-ui/AppBar/AppBar';
import { connect } from 'react-redux';
import { changePlayMode } from './actions';
var ModeChooserTabs = /** @class */ (function (_super) {
    __extends(ModeChooserTabs, _super);
    function ModeChooserTabs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChange = function (event, value) {
            var playMode = { type: value === 0 ? 'test_scenario' : 'automated' };
            _this.props.changePlayMode(playMode);
        };
        return _this;
    }
    ModeChooserTabs.prototype.render = function () {
        var playMode = this.props.playMode;
        return (React.createElement("div", null,
            React.createElement(AppBar, { position: "static" },
                React.createElement(Tabs, { value: playMode.valueOf(), onChange: this.handleChange },
                    React.createElement(Tab, { label: "Test Scenario" }),
                    React.createElement(Tab, { label: "Automated testing" })))));
    };
    return ModeChooserTabs;
}(React.Component));
export default connect(function (_a) {
    var playMode = _a.playMode;
    return ({ playMode: playMode });
}, { changePlayMode: changePlayMode })(ModeChooserTabs);



//////////////////
// WEBPACK FOOTER
// ./src/containers/ModeChooserTabs/index.tsx
// module id = 1822
// module chunks = 0